// extracted by mini-css-extract-plugin
export default {"portfolio":"Portfolio_portfolio__R8g-B","portfolioItem":"Portfolio_portfolioItem__IrwgO","shine-avatar":"Portfolio_shine-avatar__9QlqA","shine-lines":"Portfolio_shine-lines__RHGeL"};